import {
  detectSponsorship,
  getBackfillData,
} from "../../../../TMAd/js/sponsorshipDetector";
import { logFeature } from "../../../../scriptsCore/js/logging.js";
import events from "@trinitymirrordigital/chameleon-core/src/js/events";
import { readConfigPath } from "../../../utils/js/configMgr.js";
import { getAllSlots } from "./slotHelpers.js";

const log = (...args) => logFeature("ads", ...args);

const advertiserExclusionIds = readConfigPath(
  "advertisingConfig.advertiserExclusionIds"
) || [
  32981537, //Google AdExchange
  4861612479, //Reach Adsense
  103255457, //Trinity Mirror AdSense
  80174537, //Google (HSK)
  95060777, //GOOGLE INC
  14290577, //GOOGLE
  87295937, //Mr Unfilled Impressions
  14719937, //Amazon
  4578381073, //AppNexus
  80177177, //AppNexus (HSK)
  71886977, //Teads
  4518234929, //Index Exchange (HB)
  4665485414, //Ozone Project
  59143937, //Rezonence
  4572516897, //SelectMedia
  14952617, //Criteo
  4842927965, //PubMatic
  85286777, //Just Premium
  14364017, //Rubicon
  81041177, //Pubmatic (HSK)
  80575697, //GumGum
  94567457, //33Across (HSK)
  4679158304, //Sharethrough
  106119737, //Insticator
  90985577, //Sublime Skinz
  99875177, //Collective
  4470217592, //Sovrn
];

function report(isSponsorship) {
  events.fire(window, "isSponsorship.ready", { isSponsorship });
}

export function init() {
  const backfillDependencies = {
    log,
    events,
    advertiserExclusionIds,
    gptExpectedSlotCount: getAllSlots().length,
  };
  const detectorDependencies = { log };
  getBackfillData(backfillDependencies).then((data) => {
    const isSponsorship = detectSponsorship(data, detectorDependencies);
    report(isSponsorship);
  });
}
